import { useEffect, useState } from 'react';
import api from '../../utils/axios';

const VACIO = { casos: [], documentos: [], timeline: [] };

// Documentos y timeline de los casos fusionados en este (solo lectura, no se copian).
export const useAbsorbidos = (caseId) => {
  const [data, setData] = useState(VACIO);
  useEffect(() => {
    if (!caseId) return;
    setData(VACIO);
    api.get(`/cases/${caseId}/absorbidos`).then((r) => setData(r.data || VACIO)).catch(() => {});
  }, [caseId]);
  return data;
};

export const etiquetaOrigen = (o) => `del caso ${o?.titulo || o?.id || ''}`;
